<template>
  <div ref="ElementoGrafico">  
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico + 50"></canvas>
  </div>      
</template>

<script>
import { TZGraphLine, TZTipologiaPointGroups } from '@/utils/ZGraph.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZGraphNotchType, TZGraphLabelType } from '@/utils/ZGraph.js'
import { TZDateFunct, MS_X_HOUR, MS_X_DAY, MS_X_MINUTE } from '@/utils/ZDateFunct'
import { TInfoGraphic } from '../../InfoGraphic.js'
import { TZMathFunct } from '@/utils/ZMathFunct'
import { TIPI_GRAFICI_STAZIONE_METEO, SystemInformation, TIPI_UDM_X } from '../../SystemInformation'

export default 
{
  components: { },
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              ObjGrafico           : null,
              Grafici              : {},
              ListaIdVisualizzati  : [],
              ListaDatiTempGrafico : [],
              LinguaUtente         : SystemInformation.UserInformation.Lingua
            }

  },
  props: [ 
            "WidthGrafico", 
            "HeightGrafico", 
            "ListaModuli",
            "ListaFalde", 
            "DatiMeteo", 
            "ObjDal", 
            "ObjAl", 
            "TipoGrafico", 
            "PropsGrafico",
            "Repaint",
            "UpdateAxes",
            "GraficiChange",
            "TempSuolo",
            "OggettoTotaleSpostamento",
         ],
  methods:
  {
    Adatta(MaxAsseY, MinAsseY, UdmY)
    {
      //Asse X
      this.ObjGrafico.AxisX.Min           = Date.parse(this.ObjDal.Data + 'T' + (this.ObjDal.Ora < 10? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = Date.parse(this.ObjAl.Data + 'T' + (this.ObjAl.Ora < 10? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = this.ObjGrafico.AxisX.Max + TZDateFunct.GetNHoursInTimeStamp(1)
      if (!this.PropsGrafico.AxisX.Modificato)
      {
        this.ObjGrafico.AxisX.NotchDim      = (Math.abs(this.ObjGrafico.AxisX.Max - this.ObjGrafico.AxisX.Min))
        this.ObjGrafico.AxisX.NotchDim      = TInfoGraphic.GetAdjustedNotchDim(this.ObjGrafico.AxisX.NotchDim, 24)        
      }
      else
      {
        switch (this.PropsGrafico.AxisX.TipoUdmX)
        {
          case TIPI_UDM_X.Giorni : 
          {
            this.ObjGrafico.AxisX.NotchDim = 24 * 60 * 60 * 1000 * this.PropsGrafico.AxisX.UdmX
            break
          }
          case TIPI_UDM_X.Ore    : 
          {
            this.ObjGrafico.AxisX.NotchDim = 60 * 60 * 1000 * this.PropsGrafico.AxisX.UdmX
            break
          }
          case TIPI_UDM_X.Minuti : 
          {
            this.ObjGrafico.AxisX.NotchDim = 60 * 1000 * this.PropsGrafico.AxisX.UdmX
            break
          }
        }        
      }
      this.ObjGrafico.AxisX.OffsetNotch   = this.ObjGrafico.AxisX.NotchDim
      this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
      this.ObjGrafico.AxisX.NotchFontSize = 13

      //Asse Y
      this.ObjGrafico.AxisY.Max           = MaxAsseY
      this.ObjGrafico.AxisY.Min           = MinAsseY
      this.ObjGrafico.AxisY.NotchDim      = UdmY
      this.ObjGrafico.AxisY.OffsetNotch   = Math.abs(MinAsseY) - TZMathFunct.GetMultiplo(Math.abs(MinAsseY), UdmY, 'Difetto')
      // this.ObjGrafico.AxisY.Max           = 50     
      // this.ObjGrafico.AxisY.Min           = -50        
      // this.ObjGrafico.AxisY.NotchDim      = 10
      // this.ObjGrafico.AxisY.OffsetNotch   = 0
      // this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblDecimi
      this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))

      // setTimeout(() => { this.ObjGrafico.Paint() }, 1)
    },


    Disegna(AssePrincipale, UpdateAsse)
    {
      if(AssePrincipale != null)
        this.Adatta(AssePrincipale.Max, AssePrincipale.Min, AssePrincipale.Udm)

      this.InserisciDati(UpdateAsse)
      setTimeout(() => 
      {
        this.ObjGrafico.Paint()
      })
    },

    InserisciDati(UpdateAsse)
    {
      this.Grafici = {}
      this.ObjGrafico.ClearAllGroupPoint()

      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.Spostamenti) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.Spostamenti)
        this.InserisciDatiSpostamenti()

      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.Vento) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.Vento)
        this.InserisciDatiVento(UpdateAsse)

      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.TemperaturaAria) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.Vento)
        this.InserisciDatiTemperaturaAria(UpdateAsse)

      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.DieciMinutiPioggia) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.DieciMinutiPioggia)
        this.InserisciDatiDieciMinutiPioggia(UpdateAsse)

      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.PrecipitazioneOraria) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.PrecipitazioneOraria)
        this.InserisciDatiPrecipitazioneOraria(UpdateAsse)
      
      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.CumulativoPioggia) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.CumulativoPioggia)
        this.InserisciDatiCumulativoPioggia(UpdateAsse)
          
      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.Falda) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.Falda)
        this.InserisciDatiFalda(UpdateAsse)

      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.TemperaturaSuolo) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.TemperaturaSuolo)
        this.InserisciDatiTemperaturaSuolo(UpdateAsse)
      
      if(this.ListaIdVisualizzati.includes(TIPI_GRAFICI_STAZIONE_METEO.GiornalieroPioggia) || this.PropsGrafico.AssePrincipale == TIPI_GRAFICI_STAZIONE_METEO.GiornalieroPioggia)
        this.InserisciDatiGiornalieroPioggia(UpdateAsse)
    },

    InserisciDatiSpostamenti()
    {
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.Spostamenti? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.Spostamenti) : null;

      let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.Spostamenti)

      this.Grafici.Spostamenti = this.ObjGrafico.AddGroupPoint(1, 
                                                              ObjInfoGrafica.Colore, 
                                                              ObjInfoGrafica.Spessore, 
                                                              true, 
                                                              AssePassato)
        
      for (let i = 0; i < this.OggettoTotaleSpostamento.ListaTotaliSpostamento.length; i++)
      {
        let Dato   = this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i]
        let XCoord = Date.parse(Dato.Data)
        this.Grafici.Spostamenti.AddPoint(XCoord, Dato.SpostamentoTotale)
      }

      if (ObjInfoGrafica.Modificato)
      {
        if (AssePassato == null)
        {
          let AsseY = this.ObjGrafico.AxisY
          AsseY.Min = ObjInfoGrafica.Min
          AsseY.Max = ObjInfoGrafica.Max
          AsseY.NotchDim = ObjInfoGrafica.Udm
        }
        else
        {
          AssePassato.Min = ObjInfoGrafica.Min
          AssePassato.Max = ObjInfoGrafica.Max
          AssePassato.NotchDim = ObjInfoGrafica.Udm
        }
      }

      
    },

    InserisciDatiVento()
    {
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.Vento? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.Vento) : null;
      
      let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.Vento)
      
      this.Grafici.Vento = this.ObjGrafico.AddGroupPoint(1, 
                                                        ObjInfoGrafica.Colore, 
                                                        ObjInfoGrafica.Spessore, 
                                                        true, 
                                                        AssePassato)

      for (let i = 0; i < this.DatiMeteo.Dati.length; i++)
      {
        let Dato   = this.DatiMeteo.Dati[i]
        let XCoord = Date.parse(Dato.Data)
        this.Grafici.Vento.AddPoint(XCoord, Dato.Vento)
      }
    },

    InserisciDatiTemperaturaAria()
    {
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.TemperaturaAria? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.TemperaturaAria) : null;
      
      let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.TemperaturaAria)
      
      this.Grafici.TemperaturaAria = this.ObjGrafico.AddGroupPoint(1, 
                                                                  ObjInfoGrafica.Colore, 
                                                                  ObjInfoGrafica.Spessore, 
                                                                  true, 
                                                                  AssePassato)

      for (let i = 0; i < this.DatiMeteo.Dati.length; i++)
      {
        let Dato   = this.DatiMeteo.Dati[i]
        let XCoord = Date.parse(Dato.Data)
        this.Grafici.TemperaturaAria.AddPoint(XCoord, Dato.Temperatura)
      }
    },

    InserisciDatiCumulativoPioggia(UpdateAsse)
    {
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.CumulativoPioggia? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.CumulativoPioggia) : null;
      let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.CumulativoPioggia)
      let CumulativoPioggiaMassimo = 0

      for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
        if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == (this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PIOGGIA_CUM',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'))
          CumulativoPioggiaMassimo = this.ObjGrafico.OtherAxis[z].Max

      this.Grafici.CumulativoPioggia = this.ObjGrafico.AddGroupPoint(1, 
                                                                     ObjInfoGrafica.Colore, 
                                                                     ObjInfoGrafica.Spessore, 
                                                                     true, 
                                                                     AssePassato)

      let BaseCumulata = 0
      let LastCumulata = 0
      let LastData = 0
      let VentiMinutiInMillisecondi = 20 * 60 * 1000
      let PrimoDato = true

      for (let i = 0; i < this.DatiMeteo.Dati.length; i++)
      {
        let Dato   = this.DatiMeteo.Dati[i]
        let XCoord = Date.parse(Dato.Data)

        if(PrimoDato)
        {
          LastData = XCoord
          PrimoDato = false
        }

        if(((XCoord - LastData) >= VentiMinutiInMillisecondi) && this.PropsGrafico.CumulativoPioggia.ResetAssenzaDati)
        {
          BaseCumulata = LastCumulata
        }

        LastCumulata = Dato.PioggiaCumulata
        LastData     = XCoord

        if(Dato.PioggiaCumulata > CumulativoPioggiaMassimo)
          CumulativoPioggiaMassimo = Dato.PioggiaCumulata

        this.Grafici.CumulativoPioggia.AddPoint(XCoord, Dato.PioggiaCumulata - BaseCumulata)
      }

      // if (!ObjInfoGrafica.Modificato)
      // {
      //   if (AssePassato == null)
      //   {
      //     let AsseY = this.ObjGrafico.AxisY
      //     AsseY.NotchDim = Math.round((CumulativoPioggiaMassimo * 1.05) / 12 * 2) / 2
      //     AsseY.Max = this.ObjGrafico.AxisY.NotchDim * 12
      //     AsseY.Min = 0
      //     if (AsseY.Min == AsseY.Max)
      //     {            
      //       AsseY.Min = 0
      //       AsseY.Max = 10
      //       AsseY.NotchDim = 1
      //       AsseY.OffsetNotch = 0
      //     }
      //     ObjInfoGrafica.Min = this.ObjGrafico.AxisY.Min
      //     ObjInfoGrafica.Max = this.ObjGrafico.AxisY.Max
      //     ObjInfoGrafica.Udm = this.ObjGrafico.AxisY.NotchDim
      //   }
      //   else
      //   {
      //     for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
      //       if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == (this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PIOGGIA_CUM',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']') && CumulativoPioggiaMassimo != this.ObjGrafico.OtherAxis[z].Max)
      //       {
      //         this.ObjGrafico.OtherAxis[z].NotchDim = Math.round((CumulativoPioggiaMassimo * 1.05) / 12 * 2) / 2
      //         this.ObjGrafico.OtherAxis[z].Max = this.ObjGrafico.OtherAxis[z].NotchDim * 12
      //         ObjInfoGrafica.Min = 0
      //         ObjInfoGrafica.Max = this.ObjGrafico.OtherAxis[z].Max
      //         ObjInfoGrafica.Udm = this.ObjGrafico.OtherAxis[z].NotchDim
      //       }
      //   }
      // }
      // else
      // {   
      //   if (AssePassato == null)
      //   {
      //     let AsseY = this.ObjGrafico.AxisY
      //     AsseY.Min = ObjInfoGrafica.Min
      //     AsseY.Max = ObjInfoGrafica.Max
      //     AsseY.NotchDim = ObjInfoGrafica.Udm
      //   }
      //   else
      //   {
      //     AssePassato.Min = ObjInfoGrafica.Min
      //     AssePassato.Max = ObjInfoGrafica.Max
      //     AssePassato.NotchDim = ObjInfoGrafica.Udm
      //   }

      if (!(UpdateAsse && ObjInfoGrafica.Modificato))
      {
        if (!ObjInfoGrafica.Modificato)
        // {
        //   let TempMax = 0
        //   let TempMin = 0
        //   let TempUdm = 1
        //   if (AssePassato == null)
        //   {
        //     let AsseY      = this.ObjGrafico.AxisY 
        //     TempUdm = Math.round((CumulativoPioggiaMassimo * 1.05) / 12 * 2) / 2
        //     if (AsseY.NotchDim == 0)
        //       AsseY.NotchDim = 1
        //     TempMin = 0
        //     TempMax = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AsseY.Min > TempMin)
        //       AsseY.Min = TempMin
        //     if (AsseY.Max < TempMax)
        //       AsseY.Max = TempMax
        //     if (AsseY.Max - AsseY.Min < TempUdm)
        //       AsseY.NotchDim = TempUdm
        //   }
        //   else
        //   {     
        //     TempUdm = Math.round((CumulativoPioggiaMassimo * 1.05) / 12 * 2) / 2
        //     if (TempUdm == 0)
        //       TempUdm = 1
        //     TempMin  = 0
        //     TempMax  = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AssePassato.Min > TempMin)
        //       AssePassato.Min = TempMin
        //     if (AssePassato.Max < TempMax)
        //       AssePassato.Max = TempMax
        //   }
        // }
        // else
        {  
          if (AssePassato == null)
          {
            let AsseY = this.ObjGrafico.AxisY
            AsseY.Min = 0
            AsseY.Max = 400
            AsseY.NotchDim = 20
          }
          else
          {
            AssePassato.Min = 0
            AssePassato.Max = 400
            AssePassato.NotchDim = 20
          }  
          this.GraphData.Min = 0
          this.GraphData.Max = 400
          this.GraphData.Udm = 20              
        }
      }
      else
      {
        if (AssePassato == null)
        {
          let AsseY = this.ObjGrafico.AxisY
          AsseY.Min = ObjInfoGrafica.Min
          AsseY.Max = ObjInfoGrafica.Max
          AsseY.NotchDim = ObjInfoGrafica.Udm
        }
        else
        {
          AssePassato.Min      = ObjInfoGrafica.Min
          AssePassato.Max      = ObjInfoGrafica.Max
          AssePassato.NotchDim = ObjInfoGrafica.Udm
        }  
        this.GraphData.Min = ObjInfoGrafica.Min
        this.GraphData.Max = ObjInfoGrafica.Max
        this.GraphData.Udm = ObjInfoGrafica.Udm
      }
    },

    InserisciDatiGiornalieroPioggia(UpdateAsse)
    {
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.GiornalieroPioggia? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.GiornalieroPioggia) : null;
      let GiornalieroPioggiaMassimo = 0

      for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
        if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == (this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PIOGGIA_GG',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'))
          GiornalieroPioggiaMassimo = this.ObjGrafico.OtherAxis[z].Max

      let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.GiornalieroPioggia)

      this.Grafici.GiornalieroPioggia = this.ObjGrafico.AddGroupPoint(1, 
                                                                     ObjInfoGrafica.Colore, 
                                                                     ObjInfoGrafica.Spessore, 
                                                                     true, 
                                                                     AssePassato,
                                                                     TZTipologiaPointGroups.Histogram)
      
      this.Grafici.GiornalieroPioggia.PointWidth = MS_X_DAY
      let ListaDatiGiornalieroPioggia = this.GetDatiGiornalieroPioggia()
      
      for (let i = 0; i < ListaDatiGiornalieroPioggia.length; i++)
      {
        if(ListaDatiGiornalieroPioggia[i].Y > GiornalieroPioggiaMassimo)
          GiornalieroPioggiaMassimo = ListaDatiGiornalieroPioggia[i].Y

        this.Grafici.GiornalieroPioggia.AddPoint(ListaDatiGiornalieroPioggia[i].X, ListaDatiGiornalieroPioggia[i].Y)
      }

      // if (!ObjInfoGrafica.Modificato)
      // {
      //   if (AssePassato == null)
      //   {
      //     let AsseY      = this.ObjGrafico.AxisY 
      //     AsseY.NotchDim = Math.round((GiornalieroPioggiaMassimo * 1.05) / 12 * 2) / 2
      //     if (AsseY.NotchDim == 0)
      //       AsseY.NotchDim = 1
      //     AsseY.Min      = 0
      //     AsseY.Max      = AsseY.NotchDim * 12
      //     this.GraphData.Min = this.ObjGrafico.AxisY.Min
      //     this.GraphData.Max = this.ObjGrafico.AxisY.Max
      //     this.GraphData.Udm = this.ObjGrafico.AxisY.NotchDim
      //   }
      //   else
      //   {
      //     AssePassato.NotchDim = Math.round((GiornalieroPioggiaMassimo * 1.05) / 12 * 2) / 2
      //     if (AssePassato.NotchDim == 0)
      //       AssePassato.NotchDim = 1
      //     AssePassato.Min      = 0
      //     AssePassato.Max      = AssePassato.NotchDim * 12
      //     this.GraphData.Min = AssePassato.Min
      //     this.GraphData.Max = AssePassato.Max
      //     this.GraphData.Udm = AssePassato.NotchDim
      //   }
      // }
      // else
      // {   
      //   if (AssePassato == null)
      //   {
      //     let AsseY = this.ObjGrafico.AxisY
      //     AsseY.Min = ObjInfoGrafica.Min
      //     AsseY.Max = ObjInfoGrafica.Max
      //     AsseY.NotchDim = ObjInfoGrafica.Udm
      //   }
      //   else
      //   {
      //     AssePassato.Min = ObjInfoGrafica.Min
      //     AssePassato.Max = ObjInfoGrafica.Max
      //     AssePassato.NotchDim = ObjInfoGrafica.Udm
      //   }
      // }
      
      if (!(UpdateAsse && ObjInfoGrafica.Modificato))
      {
        if (!ObjInfoGrafica.Modificato)
        // {
        //   let TempMax = 0
        //   let TempMin = 0
        //   let TempUdm = 1
        //   if (AssePassato == null)
        //   {
        //     let AsseY      = this.ObjGrafico.AxisY 
        //     TempUdm = Math.round((GiornalieroPioggiaMassimo * 1.05) / 12 * 2) / 2
        //     if (AsseY.NotchDim == 0)
        //       AsseY.NotchDim = 1
        //     TempMin = 0
        //     TempMax = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AsseY.Min > TempMin)
        //       AsseY.Min = TempMin
        //     if (AsseY.Max > TempMax)
        //       AsseY.Max = TempMax
        //     if (AsseY.NotchDim > TempUdm)
        //       AsseY.NotchDim = TempUdm
        //   }
        //   else
        //   {     
        //     TempUdm = Math.round((GiornalieroPioggiaMassimo * 1.05) / 12 * 2) / 2
        //     if (TempUdm == 0)
        //       TempUdm = 1
        //     TempMin  = 0
        //     TempMax  = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AssePassato.Min > TempMin)
        //       AssePassato.Min = TempMin
        //     if (AssePassato.Max < TempMax)
        //       AssePassato.Max = TempMax
        //   }
        // }
        // else
        {   //ObjInfoGrafica.Udm
          if (AssePassato == null)
          {
            let AsseY = this.ObjGrafico.AxisY
            AsseY.Min = 0
            AsseY.Max = 100
            AsseY.NotchDim = 5
          }
          else
          {
            AssePassato.Min = 0
            AssePassato.Max = 100
            AssePassato.NotchDim = 5
          }  
          this.GraphData.Min = 0
          this.GraphData.Max = 100
          this.GraphData.Udm = 5      
        }
      }
      else
      {
        if (AssePassato == null)
        {
          let AsseY = this.ObjGrafico.AxisY
          AsseY.Min = ObjInfoGrafica.Min
          AsseY.Max = ObjInfoGrafica.Max
          AsseY.NotchDim = ObjInfoGrafica.Udm
        }
        else
        {
          AssePassato.Min      = ObjInfoGrafica.Min
          AssePassato.Max      = ObjInfoGrafica.Max
          AssePassato.NotchDim = ObjInfoGrafica.Udm
        }  
        this.GraphData.Min = ObjInfoGrafica.Min
        this.GraphData.Max = ObjInfoGrafica.Max
        this.GraphData.Udm = ObjInfoGrafica.Udm
      }
        
      // for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++) 
      //   if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == 'Pioggia giornaliera [mm]' && GiornalieroPioggiaMassimo != this.ObjGrafico.OtherAxis[z].Max)
      //   {
      //     this.ObjGrafico.OtherAxis[z].NotchDim = Math.round((GiornalieroPioggiaMassimo * 1.05) / 12 * 2) / 2
      //     this.ObjGrafico.OtherAxis[z].Max = this.ObjGrafico.OtherAxis[z].NotchDim * 12
      //   }
    },

    GetDatiGiornalieroPioggia()
    {
      let LastDate          = 0;
      let ValoreRiferimento = 0;
      let UltimoValore      = 0;
      let ValoreGiornaliero = 0;
      let Result            = []

      for (let i = 0; i < this.DatiMeteo.Dati.length; i++)
      {
        let Dato          = this.DatiMeteo.Dati[i]
        let DataTimeStamp = Date.parse(Dato.Data.substring(0, 10) + ' 00:00')

        if(Dato.PioggiaCumulata != null)
        {
          if(DataTimeStamp != LastDate)
          {
            if(LastDate != 0)
            {
              ValoreGiornaliero = Math.abs(UltimoValore - ValoreRiferimento);
              Result.push({ X : LastDate, Y : ValoreGiornaliero})
            }
            if(LastDate == DataTimeStamp - MS_X_DAY)
            {
              ValoreRiferimento = UltimoValore
            }
            else
            {
              if(LastDate == 0) 
                ValoreRiferimento = 0
              else ValoreRiferimento = Math.abs(Dato.PioggiaCumulata);
            }
            LastDate = DataTimeStamp
          }
          UltimoValore = Math.abs(Dato.PioggiaCumulata);
        }
      }

      if (LastDate != 0)
      {
        ValoreGiornaliero = Math.abs(UltimoValore - ValoreRiferimento);
        Result.push({ X : LastDate, Y : ValoreGiornaliero})
      }

      return Result
    },

    InserisciDatiPrecipitazioneOraria(UpdateAsse)
    {
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.PrecipitazioneOraria ? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.PrecipitazioneOraria) : null;
      let PrecipitazioneOrariaMassima = 0
      
      for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
        if(this.ObjGrafico.OtherAxis[z].Id == TIPI_GRAFICI_STAZIONE_METEO.PrecipitazioneOraria)
          PrecipitazioneOrariaMassima = this.ObjGrafico.OtherAxis[z].Max

      let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.PrecipitazioneOraria)

      this.Grafici.PrecipitazioneOraria = this.ObjGrafico.AddGroupPoint(1, 
                                                                        ObjInfoGrafica.Colore, 
                                                                        ObjInfoGrafica.Spessore, 
                                                                        true, 
                                                                        AssePassato,
                                                                        TZTipologiaPointGroups.Histogram)

      this.Grafici.PrecipitazioneOraria.PointWidth = MS_X_HOUR
      let ListaDatiPrecipitazioneOraria = this.GetDatiPrecipitazioneOraria()

      for (let i = 0; i < ListaDatiPrecipitazioneOraria.length; i++)
      {
        if(ListaDatiPrecipitazioneOraria[i].Y > PrecipitazioneOrariaMassima)
          PrecipitazioneOrariaMassima = ListaDatiPrecipitazioneOraria[i].Y
        this.Grafici.PrecipitazioneOraria.AddPoint(ListaDatiPrecipitazioneOraria[i].X, ListaDatiPrecipitazioneOraria[i].Y)
      }      

      if (!(UpdateAsse && ObjInfoGrafica.Modificato))
      {
        if (!ObjInfoGrafica.Modificato)
        // {
        //   let TempMax = 0
        //   let TempMin = 0
        //   let TempUdm = 1
        //   if (AssePassato == null)
        //   {
        //     let AsseY      = this.ObjGrafico.AxisY 
        //     TempUdm = Math.round((PrecipitazioneOrariaMassima * 1.10) / 12 * 2) / 2
        //     if (AsseY.NotchDim == 0)
        //       AsseY.NotchDim = 1
        //     TempMin = 0
        //     TempMax = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AsseY.Min > TempMin)
        //       AsseY.Min = TempMin
        //     if (AsseY.Max > TempMax)
        //       AsseY.Max = TempMax
        //     if (AsseY.NotchDim > TempUdm)
        //       AsseY.NotchDim = TempUdm
        //   }
        //   else
        //   {     
        //     TempUdm = Math.round((PrecipitazioneOrariaMassima * 1.10) / 12 * 2) / 2
        //     if (TempUdm == 0)
        //       TempUdm = 1
        //     TempMin  = 0
        //     TempMax  = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AssePassato.Min > TempMin)
        //       AssePassato.Min = TempMin
        //     if (AssePassato.Max < TempMax)
        //       AssePassato.Max = TempMax
        //   }
        // }
        // else
        {   //ObjInfoGrafica.Udm
          if (AssePassato == null)
          {
            let AsseY = this.ObjGrafico.AxisY
            AsseY.Min = 0
            AsseY.Max = 100
            AsseY.NotchDim = 5
          }
          else
          {
            AssePassato.Min = 0
            AssePassato.Max = 100
            AssePassato.NotchDim = 5
          }  
          this.GraphData.Min = 0
          this.GraphData.Max = 100
          this.GraphData.Udm = 5      
        }
      }
      else
      {
        if (AssePassato == null)
        {
          let AsseY = this.ObjGrafico.AxisY
          AsseY.Min = ObjInfoGrafica.Min
          AsseY.Max = ObjInfoGrafica.Max
          AsseY.NotchDim = ObjInfoGrafica.Udm
        }
        else
        {
          AssePassato.Min      = ObjInfoGrafica.Min
          AssePassato.Max      = ObjInfoGrafica.Max
          AssePassato.NotchDim = ObjInfoGrafica.Udm
        }  
        this.GraphData.Min = ObjInfoGrafica.Min
        this.GraphData.Max = ObjInfoGrafica.Max
        this.GraphData.Udm = ObjInfoGrafica.Udm
      }
    },

    GetDatiPrecipitazioneOraria()
    {
      let Result = []
      let StartingOraEspressaInOre = 0;
      let Valore                   = 0;
      let CumulataOra              = 0;

      for (let i = 0; i < this.DatiMeteo.Dati.length; i++)
      { 
        let Dato = this.DatiMeteo.Dati[i]
        var ValoreValido = false
        if(Dato.PioggiaCumulata != null)
        {
          // let OraCampioneEspressaInOre = Math.trunc(Date.parse(Dato.Data) / MS_X_HOUR)
          let OraCampioneEspressaInOre = Date.parse(Dato.Data.substring(0, 13) + ':00:00')

          if(StartingOraEspressaInOre == 0)
          {
            CumulataOra  = Dato.PioggiaCumulata 
            Valore       = 0;
            ValoreValido = true;
          }
          else
          {
            if(OraCampioneEspressaInOre >= StartingOraEspressaInOre + MS_X_HOUR)
            {
              if(OraCampioneEspressaInOre == StartingOraEspressaInOre + MS_X_HOUR)
              {
                Valore = Math.abs(Dato.PioggiaCumulata) - Math.abs(CumulataOra)
                ValoreValido = Valore != 0
              }
              else
                ValoreValido = false
              
              CumulataOra = Dato.PioggiaCumulata
            }
            else continue;
          }

          StartingOraEspressaInOre = OraCampioneEspressaInOre;
            
        }
        if(ValoreValido)
          Result.push({X : Date.parse(Dato.Data.substring(0, 13) + ':00:00'), Y : Math.abs(Valore)})
      }

      return Result

      // let LastDate          = 0;
      // let ValoreRiferimento = 0;
      // let UltimoValore      = 0;
      // let ValoreOrario      = 0;
      // let Result            = []

      // for (let i = 0; i < this.DatiMeteo.Dati.length; i++)
      // {
      //   let Dato          = this.DatiMeteo.Dati[i]
      //   let DataTimeStamp = Date.parse(Dato.Data.substring(0, 13) + ':00')

      //   if(Dato.PioggiaCumulata != null)
      //   {
      //     if(DataTimeStamp != LastDate)
      //     {
      //       if(LastDate != 0)
      //       {
      //         ValoreOrario = Math.abs(UltimoValore - ValoreRiferimento)
      //         Result.push({ X : LastDate, Y : ValoreOrario})
      //       }
      //       if(LastDate == DataTimeStamp - MS_X_HOUR)
      //       {
      //         ValoreRiferimento = UltimoValore
      //       }
      //       else
      //       {
      //         if(LastDate == 0) 
      //           ValoreRiferimento = 0
      //         else ValoreRiferimento = Math.abs(Dato.PioggiaCumulata);
      //       }
      //       LastDate = DataTimeStamp
      //     }
      //     UltimoValore = Math.abs(Dato.PioggiaCumulata);
      //   }
      // }

      // if (LastDate != 0)
      // {
      //   ValoreOrario = Math.abs(UltimoValore - ValoreRiferimento);
      //   Result.push({ X : LastDate, Y : ValoreOrario})
      // }

      // return Result
    },
    
    InserisciDatiTemperaturaSuolo(UpdateAsse)
    {
      let ObjGraficoTempSuolo = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.TemperaturaSuolo)
      let TemperaturaMinima = 0
      let TemperaturaMassima = 0
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.TemperaturaSuolo? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.TemperaturaSuolo) : null;


      for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
        if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == (this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TEMP_SUOLO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'))
        {
          TemperaturaMinima  = this.ObjGrafico.OtherAxis[z].Min
          TemperaturaMassima = this.ObjGrafico.OtherAxis[z].Max
        }

      for (let i = 0; i < this.TempSuolo.Sensori.length; i++)
      { 
        if(this.TempSuolo.Sensori[i].Id == ObjGraficoTempSuolo.Modulo) 
        {
          let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.TemperaturaSuolo)
          
          this.Grafici.TemperaturaSuolo = this.ObjGrafico.AddGroupPoint(1, 
                                                                        ObjInfoGrafica.Colore, 
                                                                        ObjInfoGrafica.Spessore, 
                                                                        true, 
                                                                        AssePassato)

          this.ListaDatiTempGrafico = []
          this.ListaDatiTempGrafico = this.TempSuolo.Sensori[i].Dati
          this.ListaDatiTempGrafico.sort(function(a,b)
          {
            if(a.Data < b.Data)
              return -1
            if(a.Data > b.Data)
              return 1
            return 0
          })

          for (let j = 0; j < this.ListaDatiTempGrafico.length; j++)
          {
            let Dato   = this.ListaDatiTempGrafico[j]
            let XCoord = Date.parse(Dato.Data)
            if(Dato.Temperatura < TemperaturaMinima)
              TemperaturaMinima = Dato.Temperatura
            if(Dato.Temperatura > TemperaturaMassima)
              TemperaturaMassima = Dato.Temperatura
            this.Grafici.TemperaturaSuolo.AddPoint(XCoord, Dato.Temperatura)
          }
          break;
        }
      }

      // if (!ObjGraficoTempSuolo.Modificato)
      // {
      //   if (AssePassato == null)
      //   {
      //     this.ObjGrafico.AxisY.NotchDim = Math.round((TemperaturaMassima * 1.05 - TemperaturaMinima) / 12 * 2) / 2
      //     this.ObjGrafico.AxisY.Min = TemperaturaMinima
      //     this.ObjGrafico.AxisY.Max = TemperaturaMinima + this.ObjGrafico.AxisY.NotchDim * 12
      //     this.GraphData.Min = this.ObjGrafico.AxisY.Min
      //     this.GraphData.Max = this.ObjGrafico.AxisY.Max
      //     this.GraphData.Udm = this.ObjGrafico.AxisY.NotchDim
      //   }
      //   else
      //   {        
      //     for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
      //       if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == (this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TEMP_SUOLO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']') && (TemperaturaMassima != this.ObjGrafico.OtherAxis[z].Max || TemperaturaMinima != this.ObjGrafico.OtherAxis[z].Min))
      //       {
      //         this.ObjGrafico.OtherAxis[z].NotchDim = Math.round((TemperaturaMassima * 1.05 - TemperaturaMinima) / 12 * 2) / 2
      //         this.ObjGrafico.OtherAxis[z].Min = TemperaturaMinima
      //         this.ObjGrafico.OtherAxis[z].Max = TemperaturaMinima + this.ObjGrafico.OtherAxis[z].NotchDim * 12
      //         this.GraphData.Min = this.ObjGrafico.OtherAxis[z].Min
      //         this.GraphData.Max = this.ObjGrafico.OtherAxis[z].Max
      //         this.GraphData.Udm = this.ObjGrafico.OtherAxis[z].NotchDim
      //       }
      //   }
      // }
      // else
      // {   
      //   if (AssePassato == null)
      //   {
      //     let AsseY = this.ObjGrafico.AxisY
      //     AsseY.Min = ObjGraficoTempSuolo.Min
      //     AsseY.Max = ObjGraficoTempSuolo.Max
      //     AsseY.NotchDim = ObjGraficoTempSuolo.Udm
      //   }
      //   else
      //   {
      //     AssePassato.Min = ObjGraficoTempSuolo.Min
      //     AssePassato.Max = ObjGraficoTempSuolo.Max
      //     AssePassato.NotchDim = ObjGraficoTempSuolo.Udm
      //   }

        
      // }
      if (!(UpdateAsse && ObjGraficoTempSuolo.Modificato))
      {
        if (!ObjGraficoTempSuolo.Modificato)
        // {
        //   let TempMax = 0
        //   let TempMin = 0
        //   let TempUdm = 1
        //   if (AssePassato == null)
        //   {
        //     let AsseY      = this.ObjGrafico.AxisY 
        //     TempUdm = Math.round((TemperaturaMassima * 1.05 - TemperaturaMinima) / 12 * 2) / 2
        //     if (AsseY.NotchDim == 0)
        //       AsseY.NotchDim = 1
        //     TempMin = 0
        //     TempMax = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AsseY.Min > TempMin)
        //       AsseY.Min = TempMin
        //     if (AsseY.Max > TempMax)
        //       AsseY.Max = TempMax
        //     if (AsseY.NotchDim > TempUdm)
        //       AsseY.NotchDim = TempUdm
        //   }
        //   else
        //   {     
        //     TempUdm = Math.round((TemperaturaMassima * 1.05 - TemperaturaMinima) / 12 * 2) / 2
        //     if (TempUdm == 0)
        //       TempUdm = 1
        //     TempMin  = 0
        //     TempMax  = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AssePassato.Min > TempMin)
        //       AssePassato.Min = TempMin
        //     if (AssePassato.Max < TempMax)
        //       AssePassato.Max = TempMax
        //   }
        // }
        // else
        {   //ObjInfoGrafica.Udm
          if (AssePassato == null)
          {
            let AsseY = this.ObjGrafico.AxisY
            AsseY.Min = 0
            AsseY.Max = 45
            AsseY.NotchDim = 5
          }
          else
          {
            AssePassato.Min = 0
            AssePassato.Max = 45
            AssePassato.NotchDim = 5
          }  
          this.GraphData.Min = 0
          this.GraphData.Max = 45
          this.GraphData.Udm = 5      
        }
      }
      else
      {
        if (AssePassato == null)
        {
          let AsseY = this.ObjGrafico.AxisY
          AsseY.Min      = ObjGraficoTempSuolo.Min
          AsseY.Max      = ObjGraficoTempSuolo.Max
          AsseY.NotchDim = ObjGraficoTempSuolo.Udm
        }
        else
        {
          AssePassato.Min      = ObjGraficoTempSuolo.Min
          AssePassato.Max      = ObjGraficoTempSuolo.Max
          AssePassato.NotchDim = ObjGraficoTempSuolo.Udm
        }  
        this.GraphData.Min = ObjGraficoTempSuolo.Min
        this.GraphData.Max = ObjGraficoTempSuolo.Max
        this.GraphData.Udm = ObjGraficoTempSuolo.Udm
      }
    },

    InserisciDatiFalda(UpdateAsse)
    {
      let ObjGraficoFalda = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.Falda)
      let FaldaMinima = 0
      let FaldaMassima = 0      
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.Falda? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.Falda) : null;

      for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
        if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == (this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_FALDA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'))
        {
          FaldaMinima  = this.ObjGrafico.OtherAxis[z].Min
          FaldaMassima = this.ObjGrafico.OtherAxis[z].Max
        }

      for (let i = 0; i < this.ListaFalde.length; i++)
      { 
        if(this.ListaFalde[i].Id == ObjGraficoFalda.Modulo) 
        {
          let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.Falda)

          this.Grafici.Falda = this.ObjGrafico.AddGroupPoint(1, 
                                                            ObjInfoGrafica.Colore, 
                                                            ObjInfoGrafica.Spessore, 
                                                            true, 
                                                            AssePassato)
          
          for (let j = 0; j < this.ListaFalde[i].Dati.length; j++)
          {
            let Dato   = this.ListaFalde[i].Dati[j]
            let XCoord = Date.parse(Dato.Data)
            if(Dato.Pressione < FaldaMinima)
              FaldaMinima = Dato.Pressione
            if(Dato.Pressione > FaldaMassima)
              FaldaMassima = Dato.Pressione
            this.Grafici.Falda.AddPoint(XCoord, Dato.Pressione)
          }
          break;
        }
      }

      // if (!ObjGraficoFalda.Modificato)
      // {
      //   if (AssePassato == null)
      //   {
      //     this.ObjGrafico.AxisY.NotchDim = Math.round((FaldaMassima * 1.10 - FaldaMinima) / 12 * 2) / 2
      //     this.ObjGrafico.AxisY.Min = FaldaMinima
      //     this.ObjGrafico.AxisY.Max = FaldaMinima + this.ObjGrafico.AxisY.NotchDim * 12
      //     this.GraphData.Min = this.ObjGrafico.AxisY.Min
      //     this.GraphData.Max = this.ObjGrafico.AxisY.Max
      //     this.GraphData.Udm = this.ObjGrafico.AxisY.NotchDim
      //   }
      //   else
      //   {        
      //     for (let z = 0; z < this.ObjGrafico.OtherAxis.length; z++)
      //       if(this.ObjGrafico.OtherAxis[z].Labels[0].Left == (this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_FALDA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']') && (FaldaMassima != this.ObjGrafico.OtherAxis[z].Max || FaldaMinima != this.ObjGrafico.OtherAxis[z].Min))
      //       {
      //         this.ObjGrafico.OtherAxis[z].NotchDim = Math.round((FaldaMassima * 1.10 - FaldaMinima) / 12 * 2) / 2
      //         this.ObjGrafico.OtherAxis[z].Min = FaldaMinima
      //         this.ObjGrafico.OtherAxis[z].Max = FaldaMinima + this.ObjGrafico.OtherAxis[z].NotchDim * 12
      //         this.GraphData.Min = this.ObjGrafico.OtherAxis[z].Min
      //         this.GraphData.Max = this.ObjGrafico.OtherAxis[z].Max
      //         this.GraphData.Udm = this.ObjGrafico.OtherAxis[z].NotchDim
      //       }
      //   }
      // }
      // else
      // {   
      //   if (AssePassato == null)
      //   {
      //     let AsseY = this.ObjGrafico.AxisY
      //     AsseY.Min = ObjGraficoFalda.Min
      //     AsseY.Max = ObjGraficoFalda.Max
      //     AsseY.NotchDim = ObjGraficoFalda.Udm
      //   }
      //   else
      //   {
      //     AssePassato.Min = ObjGraficoFalda.Min
      //     AssePassato.Max = ObjGraficoFalda.Max
      //     AssePassato.NotchDim = ObjGraficoFalda.Udm
      //   }

      //   ObjGraficoFalda.Modificato = false
      // }

      if (!(UpdateAsse && ObjGraficoFalda.Modificato))
      {
        if (!ObjGraficoFalda.Modificato)
        // {
        //   let TempMax = 0
        //   let TempMin = 0
        //   let TempUdm = 1
        //   if (AssePassato == null)
        //   {
        //     let AsseY      = this.ObjGrafico.AxisY 
        //     TempUdm = Math.round((FaldaMassima * 1.10 - FaldaMinima) / 12 * 2) / 2
        //     if (AsseY.NotchDim == 0)
        //       AsseY.NotchDim = 1
        //     TempMin = 0
        //     TempMax = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AsseY.Min > TempMin)
        //       AsseY.Min = TempMin
        //     if (AsseY.Max > TempMax)
        //       AsseY.Max = TempMax
        //     if (AsseY.NotchDim > TempUdm)
        //       AsseY.NotchDim = TempUdm
        //   }
        //   else
        //   {     
        //     TempUdm = Math.round((FaldaMassima * 1.10 - FaldaMinima) / 12 * 2) / 2
        //     if (TempUdm == 0)
        //       TempUdm = 1
        //     TempMin  = 0
        //     TempMax  = TempUdm * 12
        //     if (TempMin == TempMax)
        //     {
        //       TempUdm = 1
        //       TempMin = 0
        //       TempMax = 10            
        //     }
        //     if (AssePassato.Min > TempMin)
        //       AssePassato.Min = TempMin
        //     if (AssePassato.Max < TempMax)
        //       AssePassato.Max = TempMax
        //   }
        // }
        // else
        {   //ObjInfoGrafica.Udm
          if (AssePassato == null)
          {
            let AsseY = this.ObjGrafico.AxisY
            AsseY.Min = 0
            AsseY.Max = 100
            AsseY.NotchDim = 5
          }
          else
          {
            AssePassato.Min = 0
            AssePassato.Max = 100
            AssePassato.NotchDim = 5
          }  
          this.GraphData.Min = 0
          this.GraphData.Max = 100
          this.GraphData.Udm = 5      
        }
      }
      else
      {
        if (AssePassato == null)
        {
          let AsseY = this.ObjGrafico.AxisY
          AsseY.Min      = ObjGraficoFalda.Min
          AsseY.Max      = ObjGraficoFalda.Max
          AsseY.NotchDim = ObjGraficoFalda.Udm
        }
        else
        {
          AssePassato.Min      = ObjGraficoFalda.Min
          AssePassato.Max      = ObjGraficoFalda.Max
          AssePassato.NotchDim = ObjGraficoFalda.Udm
        }  
        this.GraphData.Min = ObjGraficoFalda.Min
        this.GraphData.Max = ObjGraficoFalda.Max
        this.GraphData.Udm = ObjGraficoFalda.Udm
      }
    },

    InserisciDatiDieciMinutiPioggia(UpdateAsse)
    {
      let AssePassato = this.PropsGrafico.AssePrincipale != TIPI_GRAFICI_STAZIONE_METEO.DieciMinutiPioggia? this.ObjGrafico.GetOtherAxis(TIPI_GRAFICI_STAZIONE_METEO.DieciMinutiPioggia) : null;
      
      let ObjInfoGrafica = this.GetObjectPropsGrafico(TIPI_GRAFICI_STAZIONE_METEO.DieciMinutiPioggia)
      
      this.Grafici.DieciMinutiPioggia = this.ObjGrafico.AddGroupPoint(1, 
                                                                      ObjInfoGrafica.Colore, 
                                                                      ObjInfoGrafica.Spessore, 
                                                                      true, 
                                                                      AssePassato,
                                                                      TZTipologiaPointGroups.Histogram)
     
      this.Grafici.DieciMinutiPioggia.PointWidth = 10 * MS_X_MINUTE
      
      let ListaDatiDieciMinutiPioggia = this.GetDatiDieciMinutiPioggia()
      
      
      for (let i = 0; i < ListaDatiDieciMinutiPioggia.length; i++)
        this.Grafici.DieciMinutiPioggia.AddPoint(ListaDatiDieciMinutiPioggia[i].X, ListaDatiDieciMinutiPioggia[i].Y)

      
      // if (ObjInfoGrafica.Modificato)
      // {   
      //   if (AssePassato == null)
      //   {
      //     let AsseY = this.ObjGrafico.AxisY
      //     AsseY.Min = ObjInfoGrafica.Min
      //     AsseY.Max = ObjInfoGrafica.Max
      //     AsseY.NotchDim = ObjInfoGrafica.Udm
      //   }
      //   else
      //   {
      //     AssePassato.Min = ObjInfoGrafica.Min
      //     AssePassato.Max = ObjInfoGrafica.Max
      //     AssePassato.NotchDim = ObjInfoGrafica.Udm
      //   }        
      // }
      // else
      // {  
      //   if (AssePassato == null)
      //   {
      //     let AsseY = this.ObjGrafico.AxisY         
      //     ObjInfoGrafica.Min = AsseY.Min
      //     ObjInfoGrafica.Max = AsseY.Max
      //     ObjInfoGrafica.Udm = AsseY.NotchDim
      //   }
      //   else
      //   {
      //     ObjInfoGrafica.Min = AssePassato.Min
      //     ObjInfoGrafica.Max = AssePassato.Max
      //     ObjInfoGrafica.Udm = AssePassato.NotchDim
      //   }
      // }

      if (!(UpdateAsse && ObjInfoGrafica.Modificato))
      {
        if (!ObjInfoGrafica.Modificato)
        {
          if (AssePassato == null)
          {
            let AsseY = this.ObjGrafico.AxisY
            AsseY.Min = 0
            AsseY.Max = 100
            AsseY.NotchDim = 5
          }
          else
          {
            AssePassato.Min = 0
            AssePassato.Max = 100
            AssePassato.NotchDim = 5
          }  
          this.GraphData.Min = 0
          this.GraphData.Max = 100
          this.GraphData.Udm = 5      
        }
      }
      else
      {
        if (AssePassato == null)
        {
          let AsseY = this.ObjGrafico.AxisY
          AsseY.Min      = ObjInfoGrafica.Min
          AsseY.Max      = ObjInfoGrafica.Max
          AsseY.NotchDim = ObjInfoGrafica.Udm
        }
        else
        {
          AssePassato.Min      = ObjInfoGrafica.Min
          AssePassato.Max      = ObjInfoGrafica.Max
          AssePassato.NotchDim = ObjInfoGrafica.Udm
        }  
        this.GraphData.Min = ObjInfoGrafica.Min
        this.GraphData.Max = ObjInfoGrafica.Max
        this.GraphData.Udm = ObjInfoGrafica.Udm
      }
    },

    GetDatiDieciMinutiPioggia()
    {
      let LastDate          = 0;
      let ValoreRiferimento = 0;
      let UltimoValore      = 0;
      let Valore10Minuti    = 0;
      let Result            = []

      var GetGruppo10Minuti = function (DataTimeStamp)
      {
        return Math.trunc(DataTimeStamp / (10 * MS_X_MINUTE)) * 10 * MS_X_MINUTE;
      }

      for (let i = 0; i < this.DatiMeteo.Dati.length; i++)
      { 
        let Dato          = this.DatiMeteo.Dati[i]
        let TimestampData = Date.parse(Dato.Data)
        
        if(Dato.PioggiaCumulata != null)
        {
          if(GetGruppo10Minuti(TimestampData) != GetGruppo10Minuti(LastDate))
          {
            if(LastDate != 0)
            {
              Valore10Minuti = UltimoValore - ValoreRiferimento
              if(Valore10Minuti != 0)
                Result.push({ X : LastDate, Y : Valore10Minuti})
            }
            if(LastDate == 0)
              ValoreRiferimento = 0
            else ValoreRiferimento = UltimoValore;
            LastDate = TimestampData;
          }
          UltimoValore = Dato.PioggiaCumulata;
        }
      }

      if(LastDate != 0)
      {
        Valore10Minuti = UltimoValore - ValoreRiferimento;
        Result.push({ X : LastDate, Y : Valore10Minuti})
      }

      return Result
    },

    RidisegnaCanvas(UpdateAsse = false)
    {
      if(this.PropsGrafico.AssePrincipale != null)
      {
        let AssePrincipale = this.GetObjectPropsGrafico(this.PropsGrafico.AssePrincipale) 
        this.ObjGrafico    = new TZGraphLine(this.$refs.Canvas)
        this.ObjGrafico.ResetToZero = true
        this.GraphData.OggettoGrafico = this.ObjGrafico

        this.ObjGrafico.VerticalLabelAxisX  = true
        this.ObjGrafico.DrawMarkup          = false
        this.ObjGrafico.MultipleDrawingAxis = true
        
        this.ObjGrafico.AxisY.AddLabel('', ' ' + AssePrincipale.Label)
        this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblInteger

        if(this.ObjGrafico.AxisY.NotchDim != undefined)
            this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))

        this.ObjGrafico.AxisY.Color         = AssePrincipale.Colore
        this.ObjGrafico.AxisY.NotchColor    = AssePrincipale.Colore
        this.ObjGrafico.AxisY.NotchFontSize = 13
        this.ObjGrafico.__Margins.MinBottom = 50
        this.ObjGrafico.AxisX.NotchPenWidth = 1
        this.ObjGrafico.AxisY.NotchPenWidth = 1
        this.ObjGrafico.AxisX.NotchColor    = 'grey'
        this.ObjGrafico.AxisY.NotchColor    = 'grey'

        this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime

        this.AddAxesFromPropsGrafico()

        this.Disegna(AssePrincipale, UpdateAsse)
        // setTimeout(() => { this.PaintCanvas() }, 1)
      }
      else this.Disegna(null, UpdateAsse)
      // else
      // {
        // if(this.ObjGrafico != null)
        // {
        //   var oldcanv = this.$refs.Canvas
        //   document.removeChild(oldcanv)
        // }
      // }
    },

    GetObjectPropsGrafico(Id)
    {
      let PropertyObject = Object.getOwnPropertyNames(this.PropsGrafico)
      for(let i = 0; i < PropertyObject.length; i++)
      {
        if(this.PropsGrafico[PropertyObject[i]].Id != null && this.PropsGrafico[PropertyObject[i]].Id == Id)
          return this.PropsGrafico[PropertyObject[i]]
      }
    },

    AddAxesFromPropsGrafico()
    {
      this.ObjGrafico.ClearOtherAxes()
      this.ListaIdVisualizzati = []
      let PropertyObject = Object.getOwnPropertyNames(this.PropsGrafico)
      
      for(let i = 0; i < PropertyObject.length; i++)
      {
        if(this.PropsGrafico[PropertyObject[i]].Id != null && this.PropsGrafico[PropertyObject[i]].Id != this.PropsGrafico.AssePrincipale)
        {
          if(this.PropsGrafico[PropertyObject[i]].Visualizza || this.PropsGrafico[PropertyObject[i]].Modulo != null)
          {
            this.ListaIdVisualizzati.push(this.PropsGrafico[PropertyObject[i]].Id)
            
            let OggettoGrafico        = this.ObjGrafico.AddOtherAxis()
            OggettoGrafico.IdForMultipleAxes = this.PropsGrafico[PropertyObject[i]].Id
            OggettoGrafico.AddLabel(this.PropsGrafico[PropertyObject[i]].Label)
            OggettoGrafico.NotchType  = TZGraphNotchType.notStandard
            // OggettoGrafico.LabelType  = TZGraphLabelType.lblDecimi


            OggettoGrafico.Color      = this.PropsGrafico[PropertyObject[i]].Colore
            OggettoGrafico.Max        = this.PropsGrafico[PropertyObject[i]].Max
            OggettoGrafico.Min        = this.PropsGrafico[PropertyObject[i]].Min
            OggettoGrafico.NotchDim   = this.PropsGrafico[PropertyObject[i]].Udm
            OggettoGrafico.LabelType  = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(OggettoGrafico.NotchDim))
          }
        }
      }
    }

  },

  computed:
  { 
    GraphData:
    {
      get()
      {
        return this.PropsGrafico
      }
    }
  },

  watch:
  {
    Repaint:
    {
      handler()
      {
        this.RidisegnaCanvas()
      }
    },

    UpdateAxes:
    {
      handler()
      {
        this.RidisegnaCanvas(true)
      }
    },

    GraficiChange:
    {
      handler()
      {
        this.RidisegnaCanvas()
      }
    },
  },

  mounted()
  {
    this.RidisegnaCanvas()
  },

}
</script>